import { jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useResponsive } from "../../ResponsiveWrapper/index.js";
const ExpandableTextArea = ({ textareaRef, setMinHeight, id, inputValue, placeholder, handleChange, handleKeyDown, disabled, slots = {
    textareaSlot: ''
} })=>{
    const { md } = useResponsive();
    useEffect(()=>{
        setMinHeight(md ? 24 : 20);
    }, [
        md,
        setMinHeight
    ]);
    return /*#__PURE__*/ jsx("textarea", {
        ref: textareaRef,
        id: id,
        value: inputValue,
        "aria-label": placeholder || 'Message input',
        onChange: handleChange,
        onKeyDown: handleKeyDown,
        placeholder: placeholder,
        disabled: disabled,
        className: slots.textareaSlot,
        rows: 1
    });
};
export { ExpandableTextArea };
